export default __webpack_public_path__ + "resources/icons/n321-d510.png";